import Axios from './axios';
const newPath = '/api/app/bizdatarule';
export class DataRuleApi {
    // 检测规则
    testRules(params) {
        return Axios.post(`${newPath}/check`, params);
    }
}
